import styled from 'styled-components';

export const AccordionCont = styled.div`
  display: flex;
  flex-direction: column;

  div[data-testid="accordionTile"]:last-child {
    border-radius: 0 0 8px 0;
  }
`;
